import React from 'react';

function Contact() {
    return (
        <div>
            <div className='contact'>
                <h3>&#128275;&nbsp;<i>Get that <a href='https://accounts.google.com/signin/v2/identifier?flowName=GlifWebSignIn&flowEntry=ServiceLogin'>#Home</a> you need!</i></h3>
                <p><marquee>Drop your mail-id!&nbsp;&#128233;</marquee></p>
                <div className='contact-input'>
                    <input type='email' placeholder='example@gmail.com'/>
                    <a href='#'>Continue &rarr;</a>
                </div>
            </div>
        </div>
    )
}

export default Contact;
